import React, { FC } from 'react';
import { WebpagePreview } from 'components/WebpagePreview/WebpagePreview';
import { useAppStore } from 'stores/appStore';
import { useTranslation } from '@wix/wix-i18n-config';

export const SelectNameStepPreview: FC = () => {
  const { t } = useTranslation();
  const storeName = useAppStore((state) => state.storeName);

  return (
    <WebpagePreview
      headerTitle={storeName || t('select-name-step.preview.header-title.fallback')}
      skeletonEnabled={false}
    />
  );
};
